// extracted by mini-css-extract-plugin
export default {"numberContainer":"NumberInput_numberContainer__RZbHM","numberInput":"NumberInput_numberInput__p7lTo"};